import routeConfig from './config/routerConfig'

export default [
  {
    path: routeConfig.shopDetail,
    name: 'shopDetail',
    async component(resolve) {
      resolve(
        await import(
          /* webpackChunkName: 'shop' */
          '@/pages-BR/shopDetail/index'
        ),
      )
    },
  },
  {
    path: routeConfig.bizoppDetail,
    name: 'bizoppDetail',
    async component(resolve) {
      resolve(
        await import(
          /* webpackChunkName: 'shop' */
          '@/pages-BR/shopDetail/index'
        ),
      )
    },
  },
  {
    path: routeConfig.shopDetailMapView,
    name: 'mapView',
    async component(resolve) {
      resolve(
        await import(
          /* webpackChunkName: 'mapvied' */
          '@/pages-BR/shopDetail/pages/mapView'
        ),
      )
    },
  },
  {
    path: routeConfig.shopDetailBaseDetail,
    name: 'shopBaseDetail',
    async component(resolve) {
      resolve(
        await import(
          /* webpackChunkName: 'shopBaseDetail' */
          '@/pages-BR/shopDetail/pages/shopBaseDetail'
        ),
      )
    },
  },
  {
    path: routeConfig.shopDetailList + ':page',
    async component(resolve) {
      resolve(
        await import(
          /* webpackChunkName: 'list' */
          '@/pages-BR/shopDetail/pages/list'
        ),
      )
    },
  },
  {
    path: routeConfig.shopDetailGallery,
    async component(resolve) {
      resolve(
        await import(
          /* webpackChunkName: 'gallery' */
          '@/pages-BR/shopDetail/pages/gallery'
        ),
      )
    },
  },
  {
    path: routeConfig.shopDetailListDetail + ':page',
    async component(resolve) {
      resolve(
        await import(
          /* webpackChunkName: 'listDetailPage' */
          '@/pages-BR/shopDetail/pages/listDetailPage'
        ),
      )
    },
  },
  {
    path: routeConfig.salesData,
    name: 'salesData',
    async component(resolve) {
      resolve(
        await import(
          /* webpackChunkName: 'shop' */
          '@/pages-BR/shopDetail/pages/saleData'
        ),
      )
    },
  },
  {
    path: routeConfig.poiErrReport,
    name: 'poiErrReport',
    async component(resolve) {
      // 地理位置错误上报页面，目前只有BR在用
      resolve(
        await import(/* webpackChunkName: 'poiErrReport' */ '@/pages-v2/PoiErrReportBR/index'),
      )
    },
  },
]
